import ButtonGroup, { ButtonGroupProps } from "@mui/material/ButtonGroup";

export type EmtButtonGroupProps = ButtonGroupProps & { nonce?: string };

export function EmtButtonGroup(props: EmtButtonGroupProps) {
  const { ...rest } = props;
  return <ButtonGroup {...rest} />;
}
